var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import Logo from '@/shared/assets/icons/blue-logo.svg';
import CloseIcon from '@/shared/assets/icons/d-close-icon.svg';
import { submitLead } from '@/shared/api/csio/api';
import { Button } from '../../button';
import { Checkbox } from '../../checkbox';
import { Field } from '../../field';
import { Radio } from '../../radio';
import s from '../form.module.scss';
var OTHER = '__other__';
var CHOICE_TYPES = new Set(['select', 'entity', 'multiselect']);
var CONTACT_MAPS = new Set(['name', 'phone', 'email']);
var CONSENT_LINKS = {
    personalData: 'https://csio-dpo.ru/personal-data/',
    privacy: 'https://csio-dpo.ru/customer-agreed/',
};
var normalizeOptions = function (options) {
    if (options === void 0) { options = []; }
    return (options || [])
        .map(function (opt) {
        var _a;
        if (typeof opt === 'string') {
            var t = opt.trim();
            return t ? { value: t, label: t } : null;
        }
        if (opt && typeof opt === 'object' && opt.label != null) {
            var label = String(opt.label).trim();
            if (!label)
                return null;
            var value = String((_a = opt.value) !== null && _a !== void 0 ? _a : label).trim() || label;
            return { value: value, label: label };
        }
        return null;
    })
        .filter(function (opt) { return Boolean(opt); });
};
var isOtherOptionLabel = function (label) {
    var t = String(label || '')
        .trim()
        .toLowerCase();
    return t === 'другое' || t === 'другой' || t === 'other';
};
var fieldAllowsOther = function (field) {
    if (field.allowOther)
        return true;
    return normalizeOptions(field.options).some(function (opt) { return isOtherOptionLabel(opt.label); });
};
var emptyValues = function (fields) {
    if (fields === void 0) { fields = []; }
    var values = {};
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        values[field.key] = field.type === 'multiselect' ? [] : '';
        values["".concat(field.key, "_other")] = '';
    }
    return values;
};
var fieldFilled = function (field, values) {
    var raw = values[field.key];
    var other = String(values["".concat(field.key, "_other")] || '').trim();
    if (field.type === 'multiselect') {
        return Array.isArray(raw) && raw.length > 0;
    }
    if (fieldAllowsOther(field) && (raw === OTHER || other)) {
        return Boolean(other);
    }
    return raw != null && String(raw).trim().length > 0;
};
var canProceedField = function (field, values) {
    if (!field.required)
        return true;
    return fieldFilled(field, values);
};
var isChoiceField = function (field) {
    return Boolean(field && CHOICE_TYPES.has(field.type));
};
var isContactField = function (field) {
    if (!field)
        return false;
    if (field.mapsTo && CONTACT_MAPS.has(field.mapsTo))
        return true;
    if (field.type === 'phone' || field.type === 'email')
        return true;
    var key = String(field.key || '').toLowerCase();
    var label = String(field.label || '').toLowerCase();
    return (['name', 'fio', 'imya', 'phone', 'telefon', 'email', 'mail'].includes(key) ||
        label.includes('фио') ||
        label.includes('имя') ||
        label.includes('телефон') ||
        label.includes('email') ||
        label.includes('почт'));
};
var isCourseField = function (field) {
    if (!field)
        return false;
    if (field.mapsTo === 'course')
        return true;
    if (field.type === 'entity')
        return true;
    var key = String(field.key || '').toLowerCase();
    return key === 'course' || key === 'kurs' || key === 'kursy' || key === 'program';
};
var buildSteps = function (fields) {
    if (fields === void 0) { fields = []; }
    var quizSteps = [];
    var signupFields = [];
    for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
        var field = fields_2[_i];
        if (isContactField(field) || isCourseField(field)) {
            signupFields.push(field);
        }
        else {
            quizSteps.push({ kind: 'field', field: field });
        }
    }
    var steps = __spreadArray([], quizSteps, true);
    if (signupFields.length) {
        steps.push({ kind: 'contacts', fields: signupFields });
    }
    return steps;
};
var fieldInputType = function (field) {
    if (field.type === 'email' || field.mapsTo === 'email')
        return 'email';
    if (field.type === 'phone' || field.mapsTo === 'phone')
        return 'phone';
    return 'text';
};
export var LeadForm = function (_a) {
    var form = _a.form, config = _a.config, style = _a.style, onClose = _a.onClose, initialValues = _a.initialValues;
    var fields = form.fields || [];
    var steps = useMemo(function () { return buildSteps(fields); }, [fields]);
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var _c = useState(function () { return (__assign(__assign({}, emptyValues(fields)), initialValues)); }), values = _c[0], setValues = _c[1];
    var _d = useState(false), consentPersonal = _d[0], setConsentPersonal = _d[1];
    var _e = useState(false), consentPrivacy = _e[0], setConsentPrivacy = _e[1];
    var _f = useState(false), isSubmitted = _f[0], setIsSubmitted = _f[1];
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    useEffect(function () {
        setStep(0);
        setValues(__assign(__assign({}, emptyValues(fields)), (initialValues || {})));
        setConsentPersonal(false);
        setConsentPrivacy(false);
        setIsSubmitted(false);
        // Reset when form identity or prefills change meaningfully.
    }, [form.key, JSON.stringify(initialValues || {})]);
    useEffect(function () {
        if (!isSubmitted)
            return undefined;
        var timeout = setTimeout(function () {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            setIsSubmitted(false);
        }, 3000);
        return function () { return clearTimeout(timeout); };
    }, [isSubmitted, onClose]);
    var total = steps.length;
    var safeStep = Math.min(Math.max(step, 0), Math.max(total - 1, 0));
    var current = steps[safeStep];
    var isLast = safeStep >= total - 1;
    var isContacts = (current === null || current === void 0 ? void 0 : current.kind) === 'contacts';
    var setField = function (key, next) {
        setValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = next, _a)));
        });
    };
    var stepReady = function () {
        if (!current)
            return false;
        if (isContacts) {
            var fieldsOk = current.fields.every(function (f) { return canProceedField(f, values); });
            return fieldsOk && consentPersonal && consentPrivacy;
        }
        return canProceedField(current.field, values);
    };
    var handleMultiToggle = function (field, optionValue) {
        var currentValue = values[field.key];
        var selected = Array.isArray(currentValue) ? currentValue : [];
        var next = selected.includes(optionValue)
            ? selected.filter(function (v) { return v !== optionValue; })
            : __spreadArray(__spreadArray([], selected, true), [optionValue], false);
        setField(field.key, next);
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, fields_3, f, formData, _a, fields_4, f, raw, other, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    for (_i = 0, fields_3 = fields; _i < fields_3.length; _i++) {
                        f = fields_3[_i];
                        if (f.required && !fieldFilled(f, values)) {
                            toast.error("\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u00AB".concat(f.label, "\u00BB"));
                            return [2 /*return*/];
                        }
                    }
                    if (!consentPersonal || !consentPrivacy) {
                        toast.error('Необходимо дать согласия');
                        return [2 /*return*/];
                    }
                    formData = {};
                    for (_a = 0, fields_4 = fields; _a < fields_4.length; _a++) {
                        f = fields_4[_a];
                        raw = values[f.key];
                        other = String(values["".concat(f.key, "_other")] || '').trim();
                        if (f.type === 'multiselect') {
                            if (Array.isArray(raw) && raw.length)
                                formData[f.key] = raw;
                        }
                        else if (fieldAllowsOther(f) && other) {
                            formData[f.key] = OTHER;
                            formData["".concat(f.key, "_other")] = other;
                        }
                        else if (raw != null && String(raw)) {
                            formData[f.key] = String(raw);
                        }
                    }
                    formData.consent_personal_data = true;
                    formData.consent_privacy = true;
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, submitLead(config, {
                            type: form.key,
                            contact: {},
                            formData: formData,
                            source: {
                                page: typeof window !== 'undefined' ? window.location.pathname : '/',
                                form: form.key,
                                consent: CONSENT_LINKS,
                            },
                        })];
                case 2:
                    _b.sent();
                    setIsSubmitted(true);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    toast.error(err_1 instanceof Error ? err_1.message : 'Ошибка при отправке формы');
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleNext = function () {
        if (!current)
            return;
        if (!stepReady()) {
            toast.error(isContacts
                ? 'Заполните контакты и отметьте согласия'
                : 'Заполните поле, чтобы продолжить');
            return;
        }
        if (isLast) {
            void submit();
            return;
        }
        setStep(function (prev) { return Math.min(prev + 1, total - 1); });
    };
    var handleWrapperClick = function (event) {
        if (event.target === event.currentTarget) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    var renderChoiceStep = function (field) {
        var allOptions = normalizeOptions(field.options);
        var options = allOptions.filter(function (opt) { return !isOtherOptionLabel(opt.label); });
        var hasOther = fieldAllowsOther(field);
        var isMulti = field.type === 'multiselect';
        var raw = values[field.key];
        var selected = isMulti ? (Array.isArray(raw) ? raw : []) : [];
        var otherValue = String(values["".concat(field.key, "_other")] || '');
        var otherActive = !isMulti && (raw === OTHER || Boolean(otherValue.trim()));
        return (_jsxs(_Fragment, { children: [_jsxs("span", { className: s.stepTitle, children: [field.label, field.required ? '' : ' (необязательно)'] }), _jsxs("div", { className: s.options, children: [options.map(function (opt) {
                            var checked = isMulti
                                ? selected.includes(opt.value)
                                : raw === opt.value && !otherActive;
                            if (isMulti) {
                                return (_jsx("label", { className: s.option, children: _jsx(Checkbox, { checked: checked, onChange: function () { return handleMultiToggle(field, opt.value); }, label: opt.label }) }, opt.value));
                            }
                            return (_jsx("label", { className: s.option, children: _jsx(Radio, { checked: checked, onChange: function () {
                                        setField("".concat(field.key, "_other"), '');
                                        setField(field.key, opt.value);
                                    }, name: field.key, label: opt.label }) }, opt.value));
                        }), hasOther ? (_jsx(Field, { type: "text", placeholder: "\u0414\u0440\u0443\u0433\u043E\u0435", value: otherValue, onChange: function (text) {
                                setField("".concat(field.key, "_other"), text);
                                if (!isMulti) {
                                    setField(field.key, text.trim() ? OTHER : '');
                                }
                            } })) : null] })] }));
    };
    var renderContactsStep = function (contactFields) { return (_jsxs(_Fragment, { children: [_jsx("fieldset", { className: s.fieldset, children: contactFields.map(function (field) {
                    if (isCourseField(field)) {
                        return (_jsx(Field, { type: "select", placeholder: field.label || 'Выбрать курс', value: String(values[field.key] || ''), onChange: function (next) { return setField(field.key, next); }, options: normalizeOptions(field.options) }, field.key));
                    }
                    return (_jsx(Field, { type: fieldInputType(field), placeholder: field.label, value: String(values[field.key] || ''), onChange: function (next) { return setField(field.key, next); } }, field.key));
                }) }), _jsxs("div", { className: s.agreements, children: [_jsx(Checkbox, { checked: consentPersonal, onChange: function () { return setConsentPersonal(function (v) { return !v; }); }, label: _jsxs("div", { children: ["\u0414\u0430\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430", ' ', _jsx("a", { style: { color: 'var(--bg-blue)', textDecoration: 'none' }, href: CONSENT_LINKS.personalData, target: "_blank", rel: "noopener noreferrer", children: "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445" })] }) }), _jsx(Checkbox, { checked: consentPrivacy, onChange: function () { return setConsentPrivacy(function (v) { return !v; }); }, label: _jsxs("div", { children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u0441", ' ', _jsx("a", { style: { color: 'var(--bg-blue)', textDecoration: 'none' }, href: CONSENT_LINKS.privacy, target: "_blank", rel: "noopener noreferrer", children: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438" })] }) })] })] })); };
    var renderStepContent = function () {
        if (!current)
            return null;
        if (current.kind === 'contacts') {
            return renderContactsStep(current.fields);
        }
        if (isChoiceField(current.field)) {
            return renderChoiceStep(current.field);
        }
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: s.stepTitle, children: current.field.label }), _jsx(Field, { type: fieldInputType(current.field), placeholder: current.field.label, value: String(values[current.field.key] || ''), onChange: function (next) { return setField(current.field.key, next); } })] }));
    };
    var heading = isContacts || total <= 1
        ? form.label || 'Заявка'
        : 'Подбор курса под вашу ситуацию';
    var primaryText = isLast
        ? isLoading
            ? 'Отправка…'
            : form.label || 'Отправить'
        : 'Далее';
    return (_jsx("section", { className: "".concat(s.wrapper, " form_lead form_").concat(form.key), style: style, onClick: handleWrapperClick, children: _jsxs("form", { className: s.form, onClick: function (event) { return event.stopPropagation(); }, children: [_jsx(CloseIcon, { className: s.close, onClick: onClose }), _jsx(Logo, { className: s.logo }), isSubmitted ? (_jsx("div", { className: s.content, children: _jsx("span", { className: s.span, children: "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430" }) })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: s.content, children: [_jsx("span", { className: s.span, children: heading }), _jsx("div", { className: s.stepContent, children: renderStepContent() })] }), _jsx("div", { className: s.bottom, children: _jsx(Button, { text: primaryText, className: s.button, onClick: handleNext, disabled: isLoading }) })] }))] }) }));
};
export var findLeadForm = function (forms, key) { return forms.find(function (form) { return form.key === key; }); };
export var resolveCourseOptionValue = function (form, courseTitle) {
    if (!form || !courseTitle)
        return '';
    var courseField = form.fields.find(function (field) { return isCourseField(field); });
    if (!courseField)
        return '';
    var options = normalizeOptions(courseField.options);
    var match = options.find(function (opt) { return opt.label.trim().toLowerCase() === courseTitle.trim().toLowerCase(); });
    return (match === null || match === void 0 ? void 0 : match.value) || '';
};
export var CONSULTATION_FORM_KEY = 'consultion';
export var ENROLL_FORM_KEY = 'enroll';
